import { onMounted, onUpdated, Ref, watch } from "vue";
import { useMainStore } from "@/mainStore";
import { KnownFeatureFlags } from "@cs/KnownFeatureFlags";
import { executeScripts } from "@/lib/domHelper";

export function useHtmlScripts(elementRef: Ref<Element | Element[] | null | undefined>): void {
    const executedScripts = new Set<string>();
    const mainStore = useMainStore();

    const run = async () => {
        if (!(await mainStore.isFeatureFlagActiveAsync(KnownFeatureFlags.AllowHtmlScripts.Id))) return;
        const target = elementRef.value;
        if (!target) return;
        const elements = Array.isArray(target) ? target : [target];
        for (const el of elements) executeScripts(el, executedScripts);
    };

    watch(elementRef, run);

    onMounted(run);
    onUpdated(run);
}
